export const COLUMNS_EXCLUDED_FROM_SORTING = ['tags', 'devices'];
export const ASSETS_PER_PAGE = 100;
